document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("brandSearch");
  const sections = document.querySelectorAll(".letter-section");
  searchInput.addEventListener("input", function () {
    const value = this.value.trim().toUpperCase();
    sections.forEach(section => {
      const sectionLetter = section.id.replace("letter-", "").toUpperCase();
      if (value === "") {
        section.style.display = "block"; // show all if empty
      } else if (sectionLetter.startsWith(value)) {
        section.style.display = "block"; // show matching
      } else {
        section.style.display = "none"; // hide others
      }
    });
  });
  const section = document.querySelector(".brand-list-section");
  const sticky = document.querySelector(".brand_sticky__wrap");
  const brandList = document.querySelector(".brand-list");
  const header = document.querySelector(".header__top");

  if (!section || !sticky || !brandList) return;
    function getHeaderHeight() {
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    if (rect.bottom > 0) {
      return rect.height;
    }
    return 0;
  }
  window.addEventListener("scroll", function () {
  const headerOffset = getHeaderHeight();
  const sectionTop = section.offsetTop;
  const sectionHeight = section.offsetHeight;
  const stickyHeight = sticky.offsetHeight;
  const scrollY = window.scrollY;
  if (
    scrollY + headerOffset >= sectionTop &&
    scrollY + headerOffset < sectionTop + sectionHeight - stickyHeight
  ) {
    sticky.classList.add("is-sticky");
    sticky.classList.remove("is-bottom");
    sticky.style.top = headerOffset + "px";
  } else if (
    scrollY + headerOffset >= sectionTop + sectionHeight - stickyHeight
  ) {
    sticky.classList.remove("is-sticky");
    sticky.classList.add("is-bottom");
  } else {
    sticky.classList.remove("is-sticky");
    sticky.classList.remove("is-bottom");
    sticky.style.top = "0px";
  }
});
const toggleBtn = document.querySelector(".brands-nav-toggle");
const alphabetNav = document.querySelector(".alphabet-nav");

if (toggleBtn && alphabetNav) {
  toggleBtn.addEventListener("click", function () {

    toggleBtn.classList.toggle("active");
    alphabetNav.classList.toggle("is-active");

    // Optional: aria update for accessibility
    const expanded = toggleBtn.classList.contains("active");
    toggleBtn.setAttribute("aria-expanded", expanded);
  });
}

function getTotalStickyOffset() {
    let offset = 0;
    if (header) {
      offset += header.offsetHeight;
    }
    if (sticky) {
      const isCurrentlySticky = sticky.classList.contains("is-sticky");
      const originalDisplay = sticky.style.display;
      if (sticky.offsetParent === null) {
        sticky.style.display = "block";
        sticky.style.visibility = "hidden";
        sticky.style.position = "absolute";
      }
      offset += sticky.offsetHeight;
      if (originalDisplay) sticky.style.display = originalDisplay;
      sticky.style.visibility = "";
      sticky.style.position = "";
    }
    offset += 16;  
    return offset;
  }
  document.querySelectorAll('.alphabet-link[href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (!targetElement) return;
      const offset = getTotalStickyOffset();
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });
});